/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ClosedCaptionsIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABfklEQVR4nOWVzytEURTHHwtK/AEkawtrO3Yy5Z7zPU/enDNNNtb+BmOhZvz4F2Rhr8iGjZVsLGxslFKGIaIkJIzeeIqZIfND+XHr9Op+77uf+z333I7n/ZkRBEETi04T9JjF8tUEiR6xWCbcqwQQCtVuzKWRKQHUcnIuDliunIN8PcP7JwDoPkMXSXSFRa+L8rz1otkGQR8rBhAsnUqlGl913092MnSPoPdAgt79y/F+ht5+GUCi257nNbDYGEFPSWxTJNHLsB0WnYvWLxDshqDzQHyQRS8qcKAThTlYrtgZoH1uONFd0x2Q6HgsFmsul9shP95Dvg3Uesmz4RyJ7b5xdRbBne8n2wn2EGlPBD2vzAH0MAiC1jDvJLpMsCnnXAvD1kh0KVzvoKMEXQ2/zNbBoieVlSl03bmgK9TCamK2ERK7iipshpnbCiDnWgg6WdU7iNKQJdHLMvodQw+Ky/OHvWSpIyBqFvUCZL+14RAs/UHLtEwtTuizlvlrxzNBBtFJurzGvgAAAABJRU5ErkJggg==)
 */
export const ClosedCaptionsIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M5 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3H5Zm2.03 13.7c.5.3 1.1.45 1.75.45.64 0 1.19-.13 1.66-.4.47-.25.85-.63 1.11-1.13l-1.14-.89a1.83 1.83 0 0 1-1.63 1.03 1.7 1.7 0 0 1-1.6-1.08 3.2 3.2 0 0 1-.25-1.3c0-.5.08-.94.24-1.3.16-.36.38-.63.67-.81a1.75 1.75 0 0 1 1.9 0c.28.18.5.43.67.75l1.14-.89c-.54-1.01-1.46-1.52-2.77-1.52-.66 0-1.24.15-1.75.46-.51.3-.91.73-1.2 1.3a4.39 4.39 0 0 0-.43 2c0 .78.14 1.45.43 2.01.29.57.69 1 1.2 1.32Zm6.74 0c.51.3 1.1.45 1.76.45.63 0 1.19-.13 1.66-.4.47-.25.84-.63 1.1-1.13l-1.14-.89a1.83 1.83 0 0 1-1.62 1.03 1.7 1.7 0 0 1-1.6-1.08 3.2 3.2 0 0 1-.25-1.3c0-.5.08-.94.24-1.3a1.7 1.7 0 0 1 1.6-1.1 1.86 1.86 0 0 1 1.63 1.03l1.15-.88c-.54-1.01-1.46-1.52-2.77-1.52-.66 0-1.25.15-1.76.46-.5.3-.9.73-1.2 1.3a4.39 4.39 0 0 0-.42 2c0 .78.14 1.45.43 2.01.28.57.68 1 1.2 1.32Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
